<template>
  <div class="page home">
    <div class="venues-background"></div>
    <PageHeader />
    <div v-if="slideDetailShow" id="slide-detail">
      <img src="@/assets/close2.svg" id="close-modal-button" @click="onClick" />
      <div class="slide-detail-wrapper">
        <div class="slide-detail-content">
          <template v-if="$route.params.season == 'SPRING'">
            <p>
              O-RAN PlugFests are designed to accelerate the development of
              products and solutions based on O-RAN specifications by offering
              structured testing and integration opportunities in a neutral and
              collaborative environment.
            </p>
            <p>
              At each O-RAN PlugFest, participants advance O-RAN-based
              technology and procedures for testing, deployment and operation of
              carrier-grade open, intelligent and virtualized Radio Access
              Networks (RAN).
            </p>
            <p>
              Participants at the O-RAN Global PlugFest Spring 2025 demonstrated
              progress in diverse areas, including:
            </p>
            <ul>
              <li>Automated, cloud-native RAN deployment &amp; testing</li>
              <li>
                AI-powered test automation with intelligent report analysis and
                automated test generation, enabled by Large Language Models
                (LLM)
              </li>
              <li>
                Intelligent RAN energy savings of 25 to 30 %, enabled by rApps
                on Non-Real-Time RAN Intelligent Controller (Non-RT RIC)
              </li>
              <li>
                Intelligent network efficiency and service assurance, enabled by
                cell on‑off switching rApp and xApp combined with traffic
                steering xApp
              </li>
              <li>
                Integration of open-source O-RAN components from multiple
                open-source communities in O-RAN networks
              </li>
              <li>
                Validation of transport network behavior under congestion and
                impairments for different deployment options
              </li>
              <li>E2E network performance testing in various scenarios</li>
              <li>
                Efficient cooperation enabling consistent and repeatable testing
                across labs and regions
              </li>
            </ul>
            <p>
              O-RAN Global PlugFest Spring 2025 was hosted by 22 operators, Open
              Testing and Integration Centers (OTICs) and vendor-independent
              institutions. It took place in eight venues and 19 labs around the
              world. The event ran from February to May 2025 and involved 69
              participants, some of whom took part at more than one venue.
            </p>
          </template>
          <template v-if="$route.params.season == 'FALL'">
            <p>
              O-RAN PlugFests are designed to accelerate the development of
              O-RAN based products and solutions by offering structured testing
              and integration opportunities in a neutral and collaborative
              environment.
            </p>
            <p>
              Building on the momentum of previous PlugFests, the Fall 2025
              event showcased continued evolution of open, intelligent,
              virtualized and interoperable Radio Access Network (RAN) solutions
              - with advances in automation, end-to-end integration of
              multi-vendor solutions, network optimization, energy efficiency,
              security, and more.
            </p>
            <p>
              The Fall 2025 PlugFest showcased O-RAN performance in advanced
              scenarios like autonomous network operation agent, Distributed
              Antenna Systems (DAS) and O-RAN deployment for high-speed trains.
              Proofs of concept were conducted on compact GenAI models for O-RAN
              testing. Several scenarios were tested in live networks, and some
              are already being adopted in commercial operation.
            </p>
            <p>
              O-RAN Global PlugFest Fall 2025 was hosted by 25 operators, Open
              Testing and Integration Centres (OTICs) and independent
              institutions in 19 labs worldwide. It was conducted from August to
              November 2025 with a total of 64 companies that took part, some of
              which involved in multiple venues.
            </p>
            <p>
              “Our regular PlugFests provide incentives to diverse companies and
              institutions in the RAN industry to mature innovative O-RAN based
              solutions,” said Chih-Lin I, Co-chair of O-RAN ALLIANCE’s
              Technical Steering Committee and China Mobile Chief Scientist,
              Wireless Technologies, China Mobile Research Institute. “We are
              pleased to see demonstrations of readiness of many multi-vendor
              O-RAN deployments, and also advanced use cases and scenarios
              featuring AI in the RAN. A big thank you to all hosts, labs and
              participants for their great efforts and achievements.”
            </p>
          </template>
        </div>
      </div>
    </div>
    <div class="card-wrapper">
      <div class="col card" @click="onShowHideSlideDetail">
        <swiper
          :modules="modules"
          :slides-per-view="1"
          :space-between="80"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
        >
          <swiper-slide>
            <div class="card-wrapper">
              <div class="card-content">
                <div class="card-image">
                  <template v-if="$route.params.season == 'SPRING'">
                    <img alt="News" src="@/assets/news_01.jpg" />
                  </template>
                  <template v-if="$route.params.season == 'FALL'">
                    <img alt="News" src="@/assets/news_02.png" />
                  </template>
                </div>

                <div class="card-title"></div>
                <div class="card-title-text">
                  <template v-if="$route.params.season == 'SPRING'">
                    O-RAN Global PlugFest Spring 2025, co-hosted by 22
                    operators, OTICs, and academic and research institutions
                  </template>
                  <template v-if="$route.params.season == 'FALL'"
                    >O-RAN Global PlugFest Fall 2025</template
                  >
                </div>
                <div class="card-description">
                  <div>
                    <template v-if="$route.params.season == 'SPRING'">
                      O-RAN Global PlugFest Spring 2025 was conducted from
                      February to May 2025 in 19 labs around the world. In
                      PlugFest participated A total of 69 companies participated
                      in the plugfest, with some of them attending at multiple
                      locations.
                    </template>
                    <template v-if="$route.params.season == 'FALL'"
                      >O-RAN Global PlugFest Fall 2025 was hosted by 25
                      operators, Open Testing and Integration Centres (OTICs)
                      and independent institutions in 19 labs worldwide. It was
                      conducted from August to November 2025 with a total of 64
                      companies that took part, some of which involved in
                      multiple venues.</template
                    >
                  </div>
                </div>
                <div class="card-read-more">
                  <template v-if="!slideDetailShow"
                    ><div>Read more</div></template
                  >
                  <template v-else><div>Close</div></template>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="col venues-items">
        <Venues
          :data="venues"
          :showSwitch="true"
          title="Select PlugFest venue to explore"
          :showScrenariosCombo="false"
        />
      </div>
    </div>

    <Participants
      v-if="alphabet"
      :data="alphabet"
      title="O-RAN Global PlugFest Spring/Fall 2025 Participants"
    />
    <Footer backgroundDirection="left" />
  </div>
</template>

<script src="./Home2025.js"></script>
